const matrixConfigurationOptionsMap = new Map<string, string>([
  ["SUBSTRATE_1", "Substrate"],
  ["SUBSTRATE_2", "Substrate 2"],
  ["PRODUCT", "Product"],
  ["PROPERTIES", "Properties"],
  ["BUILDING_ACTIONS", "Building Actions"],
  ["SPECIMEN_TREATMENT", "Specimen Treatment"],
  ["CONDITIONS", "Conditions"],
  ["REPETITION", "Repetition"],
]);

export default matrixConfigurationOptionsMap;
